"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = some;

var _cb = _interopRequireDefault(require("./_cb.js"));

var _isArrayLike = _interopRequireDefault(require("./_isArrayLike.js"));

var _keys2 = _interopRequireDefault(require("./keys.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Determine if at least one element in the object passes a truth test.
function some(obj, predicate, context) {
  predicate = (0, _cb.default)(predicate, context);

  var _keys = !(0, _isArrayLike.default)(obj) && (0, _keys2.default)(obj),
      length = (_keys || obj).length;

  for (var index = 0; index < length; index++) {
    var currentKey = _keys ? _keys[index] : index;
    if (predicate(obj[currentKey], currentKey, obj)) return true;
  }

  return false;
}